import Desktop from './Desktop';

export default Desktop;
